export default (event, userType, clubPremierID, yearProfile, grupoEdad, tierLvl, profGender, cpPoints, travelers, paymentMethods, cobrandCardsNumber, CPaccount, passengerData, vouchersinfo) => {
  return {
    event: event,
    userType: userType,
    clubpremierID: clubPremierID,
    // salesforceID: salesForceId,
    yearProfile: yearProfile,
    GrupoEdad: grupoEdad,
    TierLvl: tierLvl,
    profGender: profGender,
    CPpoints: cpPoints,
    travelers: travelers,
    paymentMethods: paymentMethods,
    cobrandCardsNumber: cobrandCardsNumber,
    CPaccount: CPaccount,
    passengerData: passengerData,
    vouchersinfo: vouchersinfo,
  };
};
